export const FRONTEND_GUEST_OK_KEY = 'personal_blog.frontend.guest_ok.v1';

export function isGuestAllowed() {
  return localStorage.getItem(FRONTEND_GUEST_OK_KEY) === '1';
}

export function setGuestAllowed(v: boolean) {
  localStorage.setItem(FRONTEND_GUEST_OK_KEY, v ? '1' : '0');
}

